//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import util from '@/lib/util';

export default {
    name: "selectTimeline",
    components: {},
    data() {
        return {
            id: 0,
            list: []
        };
    },
    computed: {
        project() {
            return this.$store.state.project.projectInfo
        }
    },
    methods: {
        getProject() {
            this.$store.dispatch({
                type: 'project/GetProjectById',
                id: this.id
            }).then(() => {
                this.getGroup();
            });
        },
        getGroup() {
            abp.ajax.get('/api/services/app/ProjectProgress/GetProgressesGroupings?projectId=' + this.id).then(res => {
                this.list = [];
                this.list = res.data.result.items;
            });
        },
        progresses(projectId, year, month) {
            this.$router.push({
                name: 'projectProgress',
                params: {
                    projectId: projectId,
                    year: year,
                    month: month
                }
            })
        }
    },
    created() {
        this.id = parseInt(this.$route.params.id) || 0;
        if (this.id > 0) {
            this.getProject();
        }
    }
}
